import React, { Fragment } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import { Row, Card, CardBody } from "reactstrap";
import Fullscreen from "Components/Fullscreen";

function typography() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.typography" />}
            />
            <div className="float-right">
              <Fullscreen />
            </div>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        {/* Typography */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h1 className="mb-4">
                      <span className="fa fa-heading mr-1" /> h1. Heading 1
                      <small className="font-color-1 ml-2">
                        Secondary text
                      </small>
                    </h1>
                    <h2 className="mb-4">
                      <span className="fa fa-heading mr-1" /> h2. Heading 2
                      <small className="font-color-2 ml-2">
                        Secondary text
                      </small>
                    </h2>
                    <h3 className="mb-4">
                      <span className="fa fa-heading mr-1" /> h3. Heading 3
                      <small className="font-color-3 ml-2">
                        Secondary text
                      </small>
                    </h3>
                    <h4 className="mb-4">
                      <span className="fa fa-heading mr-1" /> h4. Heading 4
                      <small className="font-color-4 ml-2">
                        Secondary text
                      </small>
                    </h4>
                    <h5 className="mb-4">
                      <span className="fa fa-heading mr-1" /> h5. Heading 5
                      <small className="font-color-5 ml-2">
                        Secondary text
                      </small>
                    </h5>
                    <h6 className="mb-4">
                      <span className="fa fa-heading mr-1" /> h6. Heading 6
                      <small className="font-color-3 ml-2">
                        Secondary text
                      </small>
                    </h6>
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Typography Ends Here */}

        {/* Typography */}
        <Row>
          <Colxx xl="12" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-hand-rock mr-1" /> Dropcaps
                    </h6>
                    <span className="text-dropcap font-color-1">At</span> vero
                    eos et accusamus et iusto odio dignissimos ducimus qui
                    blanditiis praesentium voluptatum deleniti atque corrupti
                    quos dolores et quas molestias.
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Typography Ends Here */}

        {/* Typography */}
        <Row>
          <Colxx xl="12" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-hand-rock mr-1" /> Dropcaps
                    </h6>
                    <span className="text-dropcap px-2 bg-theme-1">At</span>{" "}
                    vero eos et accusamus et iusto odio dignissimos ducimus qui
                    blanditiis praesentium voluptatum deleniti atque corrupti
                    quos dolores et quas molestias.
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Typography Ends Here */}

        {/* Typography */}
        <Row>
          <Colxx xl="12" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-hand-rock mr-1" /> Dropcaps
                    </h6>
                    <span className="text-dropcap radius-10px px-2 bg-theme-1">
                      At
                    </span>{" "}
                    vero eos et accusamus et iusto odio dignissimos ducimus qui
                    blanditiis praesentium voluptatum deleniti atque corrupti
                    quos dolores et quas molestias.
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Typography Ends Here */}
      </Fragment>
    );
}

export default typography;
